import { useFormik } from "formik";
import * as Yup from "yup";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const useSignInFormik = (opts: {
  onSubmit?: any;
  initialValues?: any;
}) => {
  const { t } = useTranslation("common");

  const memoizedT = useCallback(t, [t]);

  return useFormik({
    initialValues: {
      email: "",
      password: "",
      ...opts?.initialValues,
    },
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .required(memoizedT("signIn.form.email.required")) // Translated error message
        .email(memoizedT("signIn.form.email.email")), // Translated error message
      password: Yup.string().required(
        memoizedT("signIn.form.password.required"),
      ), // Translated error message
    }),
    onSubmit: async (values, formikHelpers) => {
      await opts.onSubmit(values, formikHelpers);
    },
  });
};
